export default "__VITE_ASSET__9f9445d6__"